import { isArray } from 'lodash';
import { synthesizeComponentTypeLabel } from '../../common/utils/page_utils';
//TODO: Refactor
export const pageShowHideComponentOptions = (state) => {
  let options = [];
  let pageElement = state.refreshPageContent ? state.refreshPageContent : {};

  const pageComponents = Object.keys(pageElement).length
    ? JSON.parse(pageElement['nocode-components'])
    : [];

  let filteredComponent = [];
  pageComponents.length > 0
    ? pageComponents.forEach((comp, index) => {
        filteredComponent = filteredComponent.concat(findComponentType(comp));
      })
    : '';

  options = options.concat(
    filteredComponent.length > 0
      ? filteredComponent.map((filteredComp) => {
          if (
            typeof filteredComp.attributes !== 'undefined' &&
            typeof filteredComp.type !== 'undefined'
          ) {
            return {
              value: filteredComp.type + ':' + filteredComp.attributes['id'],
              label:
                synthesizeComponentTypeLabel(filteredComp.type) +
                `${
                  filteredComp.attributes['title']
                    ? ` ( Name: ${filteredComp.attributes['title']}, ID: ${filteredComp.attributes['id']} )`
                    : ` ( ID: ` + filteredComp.attributes['id'] + ` )`
                }`,
            };
          }
        })
      : [],
  );
  return options;
};

export const findComponentType = (currComponent) => {
  const result = [];
  const find = (components) => {
    if (components) {
      components.forEach((item) => {
        isAttributeInComponent(item) && result.push(item);
        find(item.components);
      });
    }
  };
  if (!isArray(currComponent)) find([currComponent]);
  return result;
};

const isAttributeInComponent = (comp) => {
  return comp.type && typeof comp.attributes !== 'undefined' && comp.attributes['id'];
};
